import apiClient from "./http";

export const getPlatformContext = (token) =>
  apiClient.get(
    "/platform/context",
    token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
  );
